import React from 'react';
import { useTranslation } from 'react-i18next';

const FlagFR = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    xmlns="http://www.w3.org/2000/svg"
    className="rounded-sm"
  >
    <rect width="7" height="14" fill="#002395" />
    <rect x="7" width="6" height="14" fill="#fff" />
    <rect x="13" width="7" height="14" fill="#ED2939" />
  </svg>
);

const FlagGB = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    xmlns="http://www.w3.org/2000/svg"
    className="rounded-sm"
  >
    <rect width="20" height="14" fill="#012169" />
    <path d="M0,0 L20,14 M20,0 L0,14" stroke="#fff" strokeWidth="2.5" />
    <path d="M0,0 L20,14 M20,0 L0,14" stroke="#C8102E" strokeWidth="1.5" />
    <path d="M10,0 V14 M0,7 H20" stroke="#fff" strokeWidth="4" />
    <path d="M10,0 V14 M0,7 H20" stroke="#C8102E" strokeWidth="2.5" />
  </svg>
);

const LANGUAGES = [
  { code: 'fr', label: 'FR', Flag: FlagFR },
  { code: 'en', label: 'EN', Flag: FlagGB },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentIndex = LANGUAGES.findIndex(
    (l) => l.code === i18n.language || i18n.language.startsWith(l.code)
  );
  const activeIndex = currentIndex >= 0 ? currentIndex : 0;
  const otherLang = LANGUAGES.find((_l, i) => i !== activeIndex) || LANGUAGES[1];

  return (
    <button
      onClick={() => i18n.changeLanguage(otherLang.code)}
      className="p-2 text-gray-500 hover:text-rose-500 transition-colors rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
      aria-label={`Switch to ${otherLang.label}`}
    >
      <otherLang.Flag />
    </button>
  );
};

export default LanguageSelector;
